import { makeStyles } from '@mui/styles';
import Card from 'apollo-react/components/Card';
import Typography from 'apollo-react/components/Typography';
import React from 'react';
import { useSelector } from 'react-redux';

import { ENTITY_NAMES, STATUSES } from '../../../constants/MasterSetupConstants';
import { useTranslation } from '../../../custom-hooks/useTranslation';
import { getImportEntityProp } from '../../../selectors/BulkImportSelectors';
import { getImportCountByStatusCode, getRecordTitle } from '../../../utils/importUtils';

const useStyles = makeStyles({
  infoContainer: { margin: '15px 0px', padding: 10 },
  infoHeader: { marginBottom: 10 },
  errorMessage: { marginTop: 10, color: 'red' },
  successMessage: { marginTop: 10, color: '#00c221' },
});

export const ImportInfo = ({ importStatuses, entityName }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  const hasImportError = useSelector(getImportEntityProp(entityName, 'hasImportError'));
  const errorMessage = useSelector(getImportEntityProp(entityName, 'errorMessage'));

  const recordsWithErrorStatusCount = getImportCountByStatusCode(importStatuses, STATUSES.ERROR);
  const recordsWithCompletedStatusCount = getImportCountByStatusCode(
    importStatuses,
    STATUSES.COMPLETED
  );
  const completedTitle = getRecordTitle(recordsWithCompletedStatusCount);
  const errorTitle = getRecordTitle(recordsWithErrorStatusCount);

  const isSubmissionCode = entityName === ENTITY_NAMES.SUBMISSION_CODE;

  return (
    <Card color="dark" className={classes.infoContainer}>
      {hasImportError ? (
        <Typography className={classes.errorMessage}>{translateString(errorMessage)}</Typography>
      ) : (
        <>
          <Typography variant="title2" className={classes.infoHeader}>
            {`${translateString('Import information')}:`}
          </Typography>
          {!isSubmissionCode && (
            <>
              <Typography>{`${translateString(
                'Import with Completed Status'
              )}: ${recordsWithCompletedStatusCount} ${translateString(
                completedTitle
              )}`}</Typography>
              <Typography>{`${translateString(
                'Import with Error Status'
              )}: ${recordsWithErrorStatusCount} ${translateString(errorTitle)}`}</Typography>
            </>
          )}
          {recordsWithErrorStatusCount > 0 ? (
            <Typography className={classes.errorMessage}>
              {translateString('Please download the result file, fix errors and then re-upload')}
            </Typography>
          ) : (
            <Typography className={classes.successMessage}>
              {translateString('Import has been successfully completed')}
            </Typography>
          )}
        </>
      )}
    </Card>
  );
};
